import data from './components/index.js';
import { batchSettlement, updateApApplyEisInvoicing, checkPaymentHandler } from '../../../api/billApi';
import {
    getInvoiceOperation, getAfreshCheck, getFillLists, getApBillDeDetail, getApBillDetail, getSaveApBillDetail,
    getSupplierFineDebitQuery, getUploadApBillDetail, getExportTaskDetail, getExportTask, getUpdateAllStatus, getBatchSaveApBillDetail
} from '../../../api/billDetails';
import { dictWithUrl } from '@/components/lots/api.js';
import configs from '@/config/user.env';
const SEVEN = '7';
const exportFee = {
    2: {
        requestResults: `分公司,服务平台,供应商编号,供应商名称,站点名称,业务单号,订单类型,项目类型,业务模式,工程师名称,订单完成时间,商品名称,用户收货省,用户收货市,用户收货区县,用户收货乡镇街道,发车单号
    ,B2B成本落档区间,B2B起步价,发车单方量,B2B卸货单价,发车单里程,单价,发车单单量,总数量,总体积,总毛重,单台体积
    ,成本折扣系数,计费组2,计费组2名称,计费组5,计费组5名称,BMS业务类型,费用名称,税率,不含税总金额,含税总金额（开票）,供应商金额,工程师金额`,
        reportCode: 'accountConveyCode'
    },
    3: {
        requestResults: `会计主体,分公司,服务平台,供应商编号,供应商,客户订单号,客户商品编码,商品名称,订单类型,客户,客户属性,运输产品,发货单位名称
    ,收货单位编码,收货单位名称,顺路带回,商超,上撤样,始发市,始发区县,始发乡镇街道,目的省,目的市,目的区县,目的街道,收货地址,订单线路,业务所属月份,业务类型,费用名称
    ,发车单号,发车时间,运输单号,业务单号,车型,车牌号,单位体积(m3),单位重量(kg),体积(m3),重量(kg),实发数量,集拼单价,落档区间,不含税成本,税率,税额,含税成本,成本来源,备注`,
        reportCode: 'accountNetDOtCode'
    }
};
const REVOCATION = 0;
const CONFIRM = 1;
const BILL_CONTEMTS_TEM = { '3': 'distribution', '2': 'networkDot' };
const FIVE_HUNDRED = 500;
const TENANT_CODE = 'annto';
const APPLICATION_NAME = 'LMS-BMS';
const IS_ENGINNER = ['否', '是'];
const SUPPLIER_FINE_FLAG = 'N';
export default {
    data() {
        return {
            isInvoLoad: false,
            sendVisible: false,
            dialogVisible: false,
            isLoading: false,
            isEleLoading: false,
            isSendBack: true,
            isMail: true,
            isUpload: true,
            isShow: true,
            isRecall: true,
            loading: true,
            ifConfirm: false,
            ifRevocation: false,
            isSeal: false,
            diaShaow: false,
            isSendBackLoading: false,
            isInvoiceNo: true,
            isDisabled: true,
            isGenerationKnot: false,
            isNetworkInfos: false,
            isSettle: true,
            isRevocation: false,
            billStatus: 31,
            rowData: {},
            process: {},
            dataRow: {},
            infoData: {},
            dataObj: {
                totalAmount: '',
                totalAmt: '',
                fineAmt: ''
            },
            payObj: {
                deliveryCompany: ''
            },
            taxRateData: [],
            tableDataLists: [],
            tableDataItems: [],
            invoiceItems: [],
            invoiceLists: [],
            networkInfoLists: [],
            networkInfoItems: [],
            data,
            title: '',
            deliveryNo: '',
            titlePicture: '',
            imgUrl: '',
            status: '',
            ledgerId: '',
            recVer: '',
            addNum: '',
            allAmt: 0,
            preAmt: 0,
            replaceSettlement: '',
            taxDifference: 0,
            classification: 0,
            invoiceStatus: 0,
            activeName: 'first',
            dicData: [],
            totalAmountNumber: '',
            costTableDataItems: [],
            expenseTableData: [],
            distributionColumnItem: [],
            distributionTableData: {},
            networkDotColumnItem: [],
            networkDotTableData: {},
            distributionLenth: 0,
            billContentsTem: { '3': 'distributionTableData', '2': 'networkDotTableData' },
            ticketDeductColumnItem: [],
            ticketDeductTableData: [],
            tabTabel: {
                1: '账单明细',
                2: '网点费用',
                3: '运配费用'
            },
            billDetailStr: '1',
            distributionStr: '3',
            networkDotStr: '2',
            netWorkDotDetailColumnItem: [],
            netWorkDotDetailTableData: [],
            expenseTableLength: 0,
            netWorkDotDetailTableLength: 0,
            etdoNo: 0,
            feeHeaderCode: '',
            supplierCode: ''
        };
    },
    methods: {
        print() {
            var isNetworkInfos = this.isNetworkInfos;// true带G false不带
            let { SYS_LSRM_NEWPRINT } = window.sessionStorage;
            SYS_LSRM_NEWPRINT = JSON.parse(SYS_LSRM_NEWPRINT);
            if (isNetworkInfos) {
                if (SYS_LSRM_NEWPRINT.BILL_ACCOUNT_G) {
                    const billAccount = JSON.parse(SYS_LSRM_NEWPRINT.account_wd);
                    this.cloudPrint(billAccount);
                } else {
                    this.localPrint();
                }
            } else {
                if (SYS_LSRM_NEWPRINT.BILL_ACCOUNT) {
                    const billAccount = JSON.parse(SYS_LSRM_NEWPRINT.account_yp);
                    this.cloudPrint(billAccount);
                } else {
                    this.localPrint();
                }
            }
        },
        formatData(data) {
            data.map(item => {
                item.type = item.type !== '01' ? '服务商' : '工程师';
                switch (item.payStatus) {
                case 0:
                    item.payStatus = '未支付';
                    break;
                case 1:
                    item.payStatus = '支付失败';
                    break;
                case 2:
                    item.payStatus = '已到服务商专用户';
                    break;
                case 3:
                    item.payStatus = '已到工程师账户';
                    break;
                case 4:
                    item.payStatus = '已到服务商现汇户';
                    break;
                case 5:
                    item.payStatus = '支付中';
                    break;
                }
            });
            return data;
        },
        getSelectValue(data) {
            this.payObj = { ...this.payObj, ...data };
            this.isInvoiceNo = false;
        },
        clearData() {
            if (this.payObj.deliveryCompany === '') {
                this.deliveryNo = '';
                this.isInvoiceNo = true;
            }
        },
        inputNum(deliveryNo) {
            this.deliveryNo = deliveryNo.replace(/[^\w\.\/]/ig, '');
        },
        invoiceNoClear() { this.deliveryNo = ''; },
        handleStartClose() { this.diaShaow = false; },
        uploadInvoice() {
            this.title = '上传发票';
            this.dialogVisible = true;
        },
        previewClick(row) {
            this.titlePicture = '预览';
            this.diaShaow = true;
            this.imgUrl = row.attachmentUrl;
        },
        sendFiles() {
            this.uploadDataArr.forEach(item => {
                this.simpleUpload(item); // 简单数据上传
            });
        },
        mailClcik() { // 寄出
            const priceDifference = (this.dataObj.totalAmt - this.dataObj.fineAmt).toFixed(3) * 1000 / 1000;
            if (this.infoData.totalAmount && this.infoData.totalAmount !== 0 && (this.infoData.totalAmount > priceDifference)) {
                return this.$message.warning('已上传发票金额不能大于(付款合计金额-罚扣款金额)');
            } else {
                if (this.payObj.deliveryCompany === undefined && this.deliveryNo === undefined) {
                    return this.$message.warning('快递公司不能为空');
                }
                if (this.payObj.deliveryCompany !== SEVEN && this.deliveryNo === undefined) {
                    return this.$message.warning('快递单号不能为空');
                } else {
                    if (this.payObj.deliveryCompany === '' && this.deliveryNo === '') {
                        return this.$message.warning('快递公司或快递单号不能为空');
                    }
                }
            }
            if (priceDifference >= 0) {
                if (this.infoData.hasOwnProperty('totalAmount') === false) {
                    this.$confirm('已上传发票金额小于账单金额, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => { this.sendOut(); }).catch(() => { });
                }
                if (this.infoData.hasOwnProperty('totalAmount')) {
                    if (String(this.infoData.totalAmount) && (this.infoData.totalAmount < priceDifference)) {
                        this.$confirm('已上传发票金额小于账单金额, 是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => { this.sendOut(); }).catch(() => { });
                    }
                }
                if (this.infoData.totalAmount === priceDifference) {
                    if (this.infoData.totalAmount) {
                        this.sendOut();
                    }
                    if (this.infoData.totalAmount === 0) {
                        this.sendOut();
                    }
                }
            } else {
                this.sendOut();
            }
        },
        async fillData() {
            this.isInvoLoad = true;
            this.allAmt = 0;
            await getFillLists({ apBillNo: this.$route.query.apBillNo }).then(res => {
                if (res && res.code === '0') {
                    this.preAmt = 0;
                    this.invoiceLists = res.data.list.map(item => {
                        if (item.amt !== '' || item.amt !== null) {
                            this.allAmt += item.amt;
                        }
                        if (item.invoiceSource === '4') {
                            this.preAmt += item.amt;
                        }
                        return item;
                    });
                    this.isInvoLoad = false;
                    if (this.replaceSettlement === 0) {
                        this.infoData.totalAmount = this.addNum = this.allAmt.toFixed(3) * 1000 / 1000;
                    }
                }
            }).catch(() => { this.isInvoLoad = false; });
        },
        handleDialog(formName) {
            if (formName.state) {
                const formLists = formName.data;
                const formData = new FormData();
                formData.append('taxNo', formLists.taxNo);
                formData.append('invoiceNo', formLists.invoiceNo);
                formData.append('invoiceCode', formLists.invoiceNumber);
                formData.append('invoiceDate', formLists.billingDate);
                formData.append('invoiceAmount', formLists.invoiceAmount);
                formData.append('invoiceType', formLists.invoiceType);
                formData.append('businessId', this.$route.query.jobid);
                formData.append('systemSource', '10');
                this.$refs.dialogVisible.isDialogLoading = true;
                getAfreshCheck(formData).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('重新查验成功'); this.$refs.dialogVisible.isDialogLoading = false;
                        this.$refs.dialogVisible.isReexamination = true; this.$refs.dialogVisible.isDell = false;
                    } else {
                        this.$refs.dialogVisible.isDialogLoading = false;
                        this.$refs.dialogVisible.isReexamination = false; this.$refs.dialogVisible.isDell = true;
                    }
                    this.fillData();
                }).catch(() => { });
            } else {
                return false;
            }
        },
        openMsgConfirmbox(msg = '', config = {}) {
            return this.$msgbox({
                title: '请确认',
                message: msg,
                type: 'info',
                showCancelButton: true,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                confirmButtonText: '是',
                cancelButtonText: '否',
                ...config
            });
        },
        billApply() {
            if (this.infoData.settlementProcess !== 1) {
                this.$message({
                    type: 'error',
                    message: '账单号:' + this.infoData.apBillNo + '不属于应付变革上线范围,请联系分公司财务发起付款申请!'
                });
                return false;
            }
            if (this.infoData.billStatus !== 40) {
                this.$message({
                    type: 'error',
                    message: '账单号:' + this.infoData.apBillNo + '状态只能为盖章确认才可以发起结算'
                });
                return false;
            }
            const paymentParams = [];
            paymentParams.push({
                jobId: this.infoData.jobId,
                apBillNo: this.infoData.apBillNo
            });

            const batchSettlementFun = (params) => {
                batchSettlement(params).then(async res => {
                    if (res.code === '0' && res.data.code === '0') {
                        // 更新付款申请智汇票开票标识
                        await updateApApplyEisInvoicing({ 'jobId': res.data.data.jobId });
                        this.$router.push({ query: { apApplyNo: res.data.data.apApplyNo, jobId: res.data.data.jobId }, path: '/bms/settleDetails' });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        }
                        );
                    }
                });
            };

            checkPaymentHandler(paymentParams).then(res => {
                if (res.data.code === '9') {
                    this.openMsgConfirmbox(res.data.msg, { dangerouslyUseHTMLString: true }).then(() => {
                        // 是
                        batchSettlementFun(JSON.parse(res.data.data));
                    }).catch(() => {
                        // 否
                    });
                } else if (res.data.code === '3') {
                    this.openMsgConfirmbox(res.data.msg, { showCancelButton: false, confirmButtonText: '关闭' });
                } else {
                    batchSettlementFun(paymentParams);
                }
            });
        },
        sendBack() {
            this.isSendBackLoading = true;
            const params = {
                deliveryCompany: this.payObj.deliveryCompany,
                deliveryNo: this.deliveryNo,
                jobId: this.$route.query.jobid
            };
            getInvoiceOperation(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('寄出撤回成功'); this.payObj.deliveryCompany = ''; this.deliveryNo = '';
                }
                this.load();
            }).finally(() => {
                this.isSendBackLoading = false;
            });
        },
        // 新增加
        apBillDetail(pageNo = 1) { // 查询 网点信息和 运配费用
            if (!this.$route.query.apBillNo) { return false; }
            getApBillDetail({ apBillNo: this.$route.query.apBillNo, pageNo, pageSize: 10 }).then(res => {
                if (res && res.code === '0') {
                    const standardType = this.$route.query.standardType;
                    if (this.infoData.isReplaceSettlement === 5) {
                        this.distributionTableData = res.data;
                    } else {
                        switch (standardType) {
                        case '2':
                            this.networkDotTableData = res.data;
                            break;
                        case '3':

                            this.distributionTableData = res.data;
                            break;
                        default:
                            break;
                        }
                    }
                }
            });
        },
        revocation() { // 撤回
            this.confirmOk(REVOCATION);
        },
        updateAllStatusTem() { // 提交确认
            if (this.$route.query.billStatus === 31) {
                // eslint-disable-next-line no-undef,standard/object-curly-even-spacing
                if (this.replaceSettlement === 0) {
                    this.supplierCode = this.supCode;
                }
                if (this.replaceSettlement === 1) {
                    this.supplierCode = this.$route.query.feeSupplierCode;
                }
                this.checkBillRecVer({ jobId: this.$route.query.jobid, recVer: this.recVer, supplierCode: this.supplierCode })
                    .then(res => {
                        if (res && res.code === '1') {
                            return this.$message.warning('该账单签署中，请稍后刷新查看');
                        }
                    });
            }
            if (this.$route.query.standardType > 1) {
                const tem = [BILL_CONTEMTS_TEM][0][this.$route.query.standardType];
                this.$refs[tem].confirm();
            } else {
                this.confirmOk();
            }
        },
        confirmOk(actionFlag = CONFIRM) {
            const params = { jobId: this.$route.query.jobid, recVer: this.recVer, apBillNo: this.$route.query.apBillNo, actionFlag };
            getUpdateAllStatus(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success(res.data);
                    this.load();
                }
            }).catch(() => { });
        },
        apBillDeDetail(page = 1, row) { // 费用明细
            if (row) {
                this.etdoNo = row.orderCode;
                this.feeHeaderCode = row.feeCode;
            }
            const pramas = { etdoNo: this.etdoNo, standardType: this.$route.query.standardType, page, pageSize: 10, apBillNo: this.$route.query.apBillNo, feeHeaderCode: this.feeHeaderCode };
            getApBillDeDetail(pramas).then(res => {
                if (res && res.code === '0') {
                    const standardType = this.$route.query.standardType;
                    switch (standardType) {
                    case this.networkDotStr: // 网点费用
                        this.netWorkDotDetailTableLength = res.data.totalCount;
                        this.netWorkDotDetailTableData = res.data.list;
                        this.netWorkDotDetailTableData.forEach(item => { item.isEngineerText = IS_ENGINNER[item.isEngineer]; });
                        break;
                    case this.distributionStr: // 运配f费用
                        this.expenseTableLength = res.data.totalCount;
                        this.expenseTableData = res.data.list;
                        break;
                    default:
                        break;
                    }
                }
            });
        },
        saveApBillDetail(data) {
            getSaveApBillDetail(data).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('保存成功');
                    this.apBillDetail();
                }
            }).catch(error => {
                this.$message.warning(error.message);
            });
        },

        saveDetails() { // 保存
            let tem = '';
            if (this.infoData.isReplaceSettlement === 5) {
                tem = [BILL_CONTEMTS_TEM][0]['3'];
            } else {
                tem = [BILL_CONTEMTS_TEM][0][this.$route.query.standardType];
            }
            this.$refs[tem].saveDistributionDetails();
        },
        saveAllDetails() { // 全部保存
            getBatchSaveApBillDetail({ apBillNo: this.$route.query.apBillNo }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('保存成功');
                    this.apBillDetail();
                }
            }).catch(error => {
                this.$message.warning(error.message);
            });
        },
        beforeUpload(file) { // 上传
            var fileNameArr = file.name.split('.');
            var fileType = fileNameArr[fileNameArr.length - 1];
            const Excel = fileType === 'xls' || fileType === 'xlsx';
            const isLt500KB = file.size / 1024 <= FIVE_HUNDRED;
            if (!Excel) {
                this.$message.warning('上传失败，文件格式只能为 xlsx 或 xls');
            } else if (!isLt500KB) {
                this.$message.warning('上传文件大小不能超过 500KB');
            }
            return Excel && isLt500KB;
        },
        afterUpload(response) {
            if (response && response.code === '0') {
                this.$message.success('导入成功');
                this.load();
            } else {
                this.$message.warning('导入失败');
            }
        },
        checkCostUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('apBillNo', this.$route.query.apBillNo);
            getUploadApBillDetail(formData)
                .then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('导入成功');
                        this.apBillDetail();
                    } else {
                        this.$message.warning('导入失败');
                    }
                });
        },
        exportFeeDetail() {
            const reportCode = exportFee[this.$route.query.standardType].reportCode;
            const data = {
                applicationCode: 'APP202009170009',
                applicationName: APPLICATION_NAME,
                apBillNo: this.$route.query.apBillNo,
                tenantCode: TENANT_CODE,
                reportCode: configs[reportCode],
                requestResults: exportFee[this.$route.query.standardType].requestResults
            };
            getExportTask(data).then();
        },
        exportTaskDetail() {
            const temp = {
                apBillNo: this.$route.query.apBillNo,
                standardType: this.$route.query.standardType
            };
            getExportTaskDetail(temp).then(res => {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = objectUrl;
                a.download = `任务明细.xlsx`;
                a.click();
            });
        },
        supplierFineDebitQuery() {
            getSupplierFineDebitQuery({ apBillNo: this.$route.query.apBillNo, checkFlag: SUPPLIER_FINE_FLAG, checkLedgerFlag: SUPPLIER_FINE_FLAG }).then(async res => {
                if (res && res.code === '0') {
                    const { data } = await dictWithUrl('BID_BUSINESS_TYPE');
                    this.ticketDeductTableData = res.data;
                    this.ticketDeductTableData.forEach(item => { item.operationTypeText = data.BID_BUSINESS_TYPE[item.operationType]; });
                }
            });
        },
        sendOut(callback) {
            const params = {
                deliveryCompany: this.payObj.deliveryCompany,
                deliveryNo: this.deliveryNo,
                jobId: this.$route.query.jobid
            };
            getInvoiceOperation(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('寄出成功');
                    callback && callback();
                }
                this.load();
            }).catch(() => { });
        }
    }
};
